import Vue from "vue";
import Router from "vue-router";

// Shared are  up another directory. @ is mapped to /src/ inside of spa
// import Home from "../views/Home.vue";
import Cart from "../views/Cart.vue";
const Precheckout = () => import('../views/Precheckout')
const Checkout = () => import('../views/Checkout')
// Don't lazy load OrderConfirmation so that the loading curtain covers up buttons until the page shows to user (as opposed to pre-rendering when lazy load is used)
import OrderConfirmation from '../views/OrderConfirmation'
const OrderAddOns = () => import('../../../shared/components/OrderAddOns.vue')
const OrderAddOnsLanding = () => import('../../../shared/components/OrderAddOnsLanding.vue')
const OrderAddOnsSearchContainer = () => import('../../../shared/components/OrderAddOnsSearchContainer.vue')
const OrderAddOnsReview = () => import('../../../shared/components/OrderAddOnsReview.vue')
const ProductDetails = () => import('../../../shared/components/product/ProductDetails.vue')

// Development Routes  - Comment before going to production
// const ShoppingListTypeahead = () => import('../../../shared/components/ShoppingListTypeahead.vue')

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/cart',
      name: 'Cart',
      component: Cart,
      meta: {
        title: route => { return 'Review Your Cart'},
        gtmEvent: 'e_cartPageLoaded',
        gtmStep: '1',
        gtmTrackItemsInCart: true
      }
    },
    {
      path: '/precheckout',
      name: 'Precheckout',
      component: Precheckout,
      meta: {
        title: route => { return 'You may also love'},
        gtmEvent: 'e_checkoutStep',
        gtmStep: '2',
        gtmTrackItemsInCart: true
      }
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: Checkout,
      meta: {
        title: route => { return 'Checkout'},
        gtmEvent: 'e_checkoutStep',
        gtmStep: '3',
        gtmTrackItemsInCart: true
      }
    },
    {
      path: '/orderconfirmation',
      name: 'OrderConfirmation',
      component: OrderConfirmation,
      meta: {
        title: route => { return 'Order Received'},
        gtmEvent: 'e_purchase',
        gtmStep: '4',
        gtmTrackItemsInCart: true
      }
    },
    {
      path: '/my-account/order-history/add-on/:orderId/',
      name: 'OrderAddOns',
      component: OrderAddOnsLanding,
      meta: {
        title: route => { return 'Add-Ons Request - Order ' + route.params.orderId },
        gtmEvent: 'e_addOnsLanding',
        gtmTrackingItemsInCart: false
      }
    },
    {
      path: '/my-account/order-history/add-on/:orderId/search',
      name: 'OrderAddOnsSearch',
      component: OrderAddOnsSearchContainer,
      meta: {
        title: route => { return 'Search Results - Order ' + route.params.orderId },
        gtmEvent: 'e_addOnsSearch'
      }
    },
    {
      path: '/my-account/order-history/add-on/:orderId/review',
      name: 'OrderAddOnsReview',
      component: OrderAddOnsReview,
      meta: {
        title: route => { return 'Review Add-Ons - Order ' + route.params.orderId },
        gtmEvent: 'e_addOnCheckoutStep',
        gtmStep: '1',
        gtmTrackItemsInCart: true
      }
    },
    {
      path: '/product-details/:id',
      name: 'ProductDetails',
      component: ProductDetails,
      meta: {
        title: route => { return 'Product Detail'}
      }
    },
    // {
    //   path: '/ShoppingListTypeahead',
    //   name: 'ShoppingListTypeahead',
    //   component: ShoppingListTypeahead
    // },
    // {
    //   path: '/checkout/schedule',
    //   name: 'checkoutSchedule',
    //   component: checkoutSchedule
    // },
    // {
    //   path: '/checkout/pay',
    //   name: 'checkoutPay',
    //   component: checkoutPay
    // }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})